import palette from '@lib/core/src/theme/palette';
import { styled, alpha, Stack, Typography } from '@mui/material';

export const NoActionsHeader = styled(Stack)({
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '12px'
});

export const NoActionsHeaderTitle = styled(Typography)({
  fontSize: '13px',
  fontWeight: '600',
  color: palette.black,
  lineHeight: '16px'
});

export const NoActionsHeaderSubtitle = styled(Typography)({
  fontSize: '13px',
  fontWeight: '500',
  color: alpha(palette.black, 0.8),
  lineHeight: '16px'
});

export const NoActionsButton = styled(Stack)({
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  padding: '10px 12px',
  borderRadius: '8px',
  backgroundColor: alpha(palette.white, 0.8)
});
